<section class="banner-style-one">
  <div class="parallax"
       style="background-image: url(/assets/images/about.png);"></div>

  <div class="breadcrums">
    <div class="container">
      <div class="row">
        <ul>
          <li>
            <a [routerLink]="['/']">
              <i class="fa-solid fa-house"></i>
              <p>Inicio</p>
            </a>
          </li>
          <li class="current">
            <p>Contacto</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="gap contact-form-2">
  <div class="heading">
    <figure>
      <img src="assets/images/heading-icon.png"
           alt="Heading Icon">
    </figure>
    <span>Siempre a tu disposición</span>
    <h2>¿Tienes dudas? ¡Estamos aquí para ayudarte!</h2>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-7">
        <div class="data">
          <p>¿Necesitas más información o tienes preguntas? Completa el formulario y nuestro equipo se pondrá en
            contacto contigo.</p>
          <form class="content-form"
                id="contact-form"
                method="post">
            <div class="row g-0">
              <input type="text"
                     name="Complete Name"
                     placeholder="Nombres"
                     required="">
            </div>
            <div class="row g-0">
              <input type="email"
                     name="Email Address"
                     placeholder="Correo"
                     required="">
            </div>
            <div class="row g-0">
              <input type="number"
                     name="Phone No"
                     placeholder="Celular"
                     required="">
            </div>
            <div class="row g-0">
              <textarea placeholder="Preguntas / Comentarios?"></textarea>
            </div>
            <button type="submit"
                    class="theme-btn">Contáctame </button>
          </form>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="info">
          <ul class="contact">
            <li>
              <i class="flaticon-maps"></i>
              <div>
                <h3>Dirección:</h3>
                <p><b>Sede Principal:</b></p>
                <p>Calle Los Granados 229, Urb. California, Trujillo</p>
                <p><b>Sede Palermo:</b></p>
                <p>Av. América Sur 1418 - Piso B, Trujillo</p>
              </div>
            </li>
            <li>
              <i class="flaticon-iphone"></i>
              <div>
                <h3>Celular:</h3>
                <a href="tel:(+51)958316491">(+51) 958 316 491</a>
              </div>
            </li>
            <li class="pb-0">
              <i class="flaticon-mail"></i>
              <div>
                <h3>Correo:</h3>
                <a href="mailto:artesmarcialestigerzendo@gmail.com">artesmarcialestigerzendo&#64;gmail.com</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
